<div class="assets-dropdown-panel" #dropdownPanel>

    <div class="organization-header" *ngIf="organizationName">
        <mat-icon class="org-icon">business</mat-icon>
        <div class="org-info">
            <span class="org-label">{{ 'HOME.ARCGIS.ORGANIZATION' | translate }}</span>
            <span class="org-name">{{organizationName}}</span>
        </div>
    </div>

    <mat-divider *ngIf="organizationName"></mat-divider>

    <div class="assets-search-container">
        <mat-form-field appearance="outline" class="search-field">
            <input matInput
                   #searchInput
                   [placeholder]="'HOME.ARCGIS.SEARCH_PLACEHOLDER' | translate"
                   [ngModel]="searchTerm"
                   (ngModelChange)="onSearchChange($event)">
            <mat-spinner matSuffix *ngIf="isLoading && !isLoadingMore" diameter="20"></mat-spinner>
            <button mat-icon-button matSuffix
                    *ngIf="searchTerm && !isLoading"
                    (click)="clearSearch()">
                <mat-icon>clear</mat-icon>
            </button>
            <mat-icon matSuffix *ngIf="!searchTerm && !isLoading">search</mat-icon>
        </mat-form-field>
    </div>

    <div class="auto-plot-container" *ngIf="hasAnyAssets || isLoading">
        <mat-slide-toggle
            [(ngModel)]="autoPlotOnMap"
            color="primary">
            {{ 'HOME.ARCGIS.AUTO_PLOT_ON_MAP' | translate }}
        </mat-slide-toggle>
        <mat-icon class="info-icon" [matTooltip]="'HOME.ARCGIS.AUTO_PLOT_ON_MAP_TOOLTIP' | translate">
            info_outline
        </mat-icon>
    </div>

    <mat-divider *ngIf="hasAnyAssets || isLoading"></mat-divider>

    <div class="assets-list" #assetsList (scroll)="onScroll($event)">
        <div class="asset-item"
             *ngFor="let asset of displayAssets"
             (click)="toggleAssetSelection(asset)">

            <mat-checkbox
                [(ngModel)]="asset.selected"
                (click)="$event.stopPropagation()"
                (change)="onAssetSelectionChange(asset)">
            </mat-checkbox>

            <div class="asset-details">
                <div class="asset-name">{{asset.name}}</div>
                <div class="asset-metadata">
                    <span class="asset-type">{{asset.typeLabel}}</span>
                    <span class="asset-separator">•</span>
                    <span class="asset-owner">{{asset.owner || ('HOME.ARCGIS.UNKNOWN_OWNER' | translate)}}</span>
                </div>
            </div>
        </div>

        <div class="loading-more" *ngIf="isLoadingMore">
            <mat-spinner diameter="24"></mat-spinner>
            <span>{{ 'HOME.ARCGIS.LOADING_MORE' | translate }}</span>
        </div>

        <div class="initial-loading" *ngIf="isInitialLoading">
            <mat-spinner diameter="32"></mat-spinner>
            <span>{{ 'HOME.ARCGIS.LOADING_ASSETS' | translate }}</span>
        </div>

        <div class="no-results" *ngIf="!isLoading && !hasAnyAssets && !searchTerm">
            <p>{{ 'HOME.ARCGIS.NO_LAYERS_AVAILABLE' | translate }}</p>
        </div>

        <div class="no-results" *ngIf="!isLoading && displayAssets.length === 0 && searchTerm">
            <p>{{ 'HOME.ARCGIS.NO_LAYERS_FOUND' | translate }}</p>
        </div>
    </div>

    <div class="assets-dropdown-footer">
        <button mat-button (click)="onClose()">
            {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button mat-raised-button
                color="primary"
                (click)="onApply()"
                [disabled]="selectedAssetsMap.size === 0">
            {{ 'HOME.ARCGIS.ADD_LAYERS' | translate }}
        </button>
    </div>
</div>
